import { createContext, useContext } from 'react';
import type { MeDto, TipusAcces } from '@/api/types';
import type { ContextAmbit } from './permisos';

export interface MeState {
  me: MeDto | null;
  carregant: boolean;
  error: unknown;
  reintenta: () => void;
  pot: (recurs: string, tipus: TipusAcces, ctx?: ContextAmbit) => boolean;
}

export const MeContext = createContext<MeState | null>(null);

export function useMe(): MeState {
  const ctx = useContext(MeContext);
  if (!ctx) throw new Error('MeContext absent');
  return ctx;
}
